// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"yQ","backgroundimage":"zQ","header":"AQ","headerwrap":"BQ","title":"CQ","promomessage":"EQ","upsellItem":"FQ","upsellImg":"GQ","helperText":"HQ","upsellHeadline":"IQ","price":"JQ","upsellGross":"KQ","upsellNet":"LQ","upsellButton":"MQ","nutritionfacts":"NQ","nutritionimg":"OQ","containerwhy":"PQ","nutritionwrappwer":"QQ","headlinewhy":"RQ","boxwhy":"SQ","textwhy":"TQ","backbutton":"UQ","drawercontainer":"VQ","logoheader":"WQ","textwrap":"XQ","timer":"YQ"};
    if(module.hot) {
      // 1715188239367
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  